/**
 * FastBundle (Rebuy FastBundle app) product detection.
 * ------------------------------------------------------------------------------
 * The app injects `window.FastBundleConf` with `bap_ids` — the array of product
 * ids that are bundle products. For those products the theme must stay out of the
 * way: it must not force variant selection (VariantPicker) nor run its own
 * add-to-cart (PdpForm), because the FastBundle widget / `window.rbrCartHandler`
 * owns that flow (its store is configured with `override_product_page_forms: false`
 * + `use_cart_hidden_attributes: true`, so it relies on the theme not interfering).
 *
 * `window.FastBundleConf` is set by the app at runtime, so this is evaluated
 * lazily at each call site (variant init time and form submit time) rather than
 * cached.
 *
 * @param {object} product - the product object from `{{ product | json }}`
 * @returns {boolean}
 */
export function isFastBundleProduct(product) {
    return !!(
        product
        && window.FastBundleConf
        && Array.isArray(window.FastBundleConf.bap_ids)
        && window.FastBundleConf.bap_ids.includes(product.id)
    );
}

export default isFastBundleProduct;
